import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 flex items-center bg-blue-50 border-l-4 border-blue-400 p-4 rounded"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col gap-2 w-full bg-white rounded-lg p-4 shadow"
}
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "text-primary-purple text-xs ml-2"
}
const _hoisted_8 = { class: "text-xs text-gray-500 break-all" }
const _hoisted_9 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showInstructions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", {
            innerHTML: _ctx.INFO_ICON,
            class: "w-6 h-6 text-blue-400 flex-shrink-0"
          }, null, 8, _hoisted_2),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ml-3 text-base text-gray-700 leading-normal" }, " To invite expert via a custom link you can copy and paste this link anywhere. For example you may share this on social media, in a Slack/Team chat, or with your Account Manager or CSM colleagues to share with their customer contacts. You have the option to decide if you want the signup link to go to your customized program landing page first or directly to the profile signup form. After you send the invites you can check the expert status in the Experts tab. ", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.invitationType === 'experts')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-sm font-medium" }, "Invite via Link", -1)),
            _createElementVNode("button", {
              class: "flex items-center gap-2 bg-gray-100 text-primary-purple px-3 py-1.5 rounded-md text-sm font-medium hover:bg-primary-purple hover:text-white transition",
              disabled: !_ctx.inviteLink,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)))
            }, [
              _createElementVNode("span", {
                innerHTML: _ctx.NOTE_ICON,
                class: "w-5 h-5"
              }, null, 8, _hoisted_6),
              _createElementVNode("span", null, _toDisplayString(_ctx.copied ? "Copied!" : "Copy Link"), 1)
            ], 8, _hoisted_5),
            (_ctx.copied)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Link Copied!"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.inviteLink), 1),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}